"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryOperation = void 0;
/**
 * A simple function that returns a promise that will automatically resolve
 * after the passed in time
 *
 * ms - time, in milliseconds, to wait before returning
 */
var wait = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
/**
 * A promise based retry helper that will retry an operation until it successfully
 * resolves or a maximum number of retries has been reached
 *
 * operation - a function that returns a promise
 * delay - time, in milliseconds, to delay between retries
 * retries - the maximum number of allowed retries
 *
 * Note: in order to avoid overengineering, the promise returned from operation must
 * currently resolve or reject with a string value.
 */
var retryOperation = function (operation, delay, retries) {
    return new Promise(function (resolve, reject) {
        return operation()
            .then(resolve)
            .catch(function (reason) {
            if (retries > 0) {
                return wait(delay)
                    .then(exports.retryOperation.bind(null, operation, delay, retries - 1))
                    .then(resolve)
                    .catch(reject);
            }
            return reject(reason);
        });
    });
};
exports.retryOperation = retryOperation;
//# sourceMappingURL=retryOperation.js.map